import { FilterType } from "../../models/filter-type.enum";
import { FilterAdapter } from "../filter-adapter.interface";
import { FilterDefaults } from "../../models/filter-defaults.model";
import { FilterOption } from "../../models/filter-option.model";

export class CommonAdapter implements FilterAdapter <any> {
  readonly type = FilterType.COMMON;

  readonly defaults: FilterDefaults = {
    multiple: false,
    searchable: false,
    removableChips: false,
    visible: true,
    disabled: true
  }

  adapt(data: any[]): FilterOption[]{
    return data.map( e => this.mapElemento(e));
  }

  adaptBusqueda(busqueda: boolean): void{
    this.defaults.searchable = busqueda;  
  }
  
  adaptConsolidado(textoConsolidado: string, consolidado: boolean): void {}

  private mapElemento(elemento: any): FilterOption{
    return {
      id: elemento.name,
      label: elemento.name,
      value: elemento,
      visible: true,
      selected: elemento.check
    }
  }
}